const topics = [
    
  
    // 2.B.1.1
    {
      title: "As Americans",
      slug: "asamericans",
      standardNumber: "2.B.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fasamericansvideo.mp4?alt=media&token=061bf961-6f30-4193-a2a9-57d0c4945357",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fasamericanssong.mp3?alt=media&token=3dac71a2-2944-49e6-94c5-125abbf4c845",
      lyrics: ["(chorus)",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty…",
        "(verse)",
        "We the American people come from many different ethnic origins.",
        "We the American people come from many different countries.",
        "The republican form of government principles unites us as Americans.",
        "The republican form of government principles unites us as Americans.",
        "(chorus)",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "The rights to life, liberty and the pursuit of happiness.",
        "© Smart Board Learning, LLC. All rights reserved.",]
    },
  
    // 2.B.1.2
    {
      title: "Native Contributions",
      slug: "nativecontributions",
      standardNumber: "2.B.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnativecontributions2025video.mp4?alt=media&token=ac5568b5-1a71-46c5-bd19-d1f7a1d74277",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnativedifferences2025song.mp3?alt=media&token=14be9668-7f68-4ab1-a9a7-41a30df34a14",
      lyrics: ["(chorus)",
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today.",  

"(verse 1)",
"Native American culture taught us things that live on.",  
"They taught us about the farming of tobacco,",  
"they taught us about the farming of corn.",  
"Native American culture taught us things we can't forget.",  
"We learned to respect nature and gain knowledge of the environment.",  
"Native American culture brought things we love in the heart.",  
"They brought us pottery, weaving, carving, and different types of arts.",  

"(chorus)",
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today,",  
"Native American contributions that we use today.",  

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Equal Rights",
      slug: "equalrights",
      standardNumber: "2.B.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fequalrights2025video.mp4?alt=media&token=58d730cc-6d5a-4889-b630-808aeabd908c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fequalrights2025song.mp3?alt=media&token=50a0be6b-0647-4069-a91b-12e34874e477",
      lyrics: ["(chorus)",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",

"(verse)",
"Susan B. Anthony helped women get equal rights.",
"That included the right to vote, that included the right to vote.",

"Jackie Robinson was the first African American",
"to play baseball in the major league, to play baseball in the major league.",

"Martin Luther King Jr. was an African American Minister",
"who worked for equal rights for all people.",

"Thurgood Marshall was a lawyer and the first African American Justice",
"of the U.S. Supreme Court, of the U.S. Supreme Court.",

"Rosa Parks was an African American Woman who refused",
"to give up her seat, and that led to a boycott",
"that helped change laws, change laws",

"(chorus)",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Dr. Martin Luther King Jr",
      slug: "drmartinlutherkingjr",
      standardNumber: "2.B.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdrmartinlutherkingjr2025video.mp4?alt=media&token=df730bc0-7199-4a8b-bf51-509505e2a40c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdrmartinlutherking2025song.mp3?alt=media&token=cfe6a225-2726-4001-8161-8d5dcff1c13d",
      lyrics: ["(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"(Verse)",
"Dr. Martin Luther King Jr. was an African American man.",
"His father was a minister and Martin was a good student.",
"He was born in 1929 on January 15th.",
"He began college when he was only 15.",
"Dr. Martin Luther King Jr. became a minister just like his dad.",
"He worked hard to change laws that were unfair.",
"Dr. Martin Luther King Jr. gave his famous speech, “I Have a Dream.”",
"He was killed one day because he fought for what he believed.",

"(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "George Washington Carver",
      slud: "georgewashingtoncarver",
      standardNumber: "2.B.1",
      description: "Understand how values and beliefs shape culture in America.",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fgeorgewashingtoncarver2025video.mp4?alt=media&token=9716d58a-ab18-4161-96e2-5ff28839b30a",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fgeorgewashingtoncarver2025song.mp3?alt=media&token=382931f7-2833-4ebe-a316-273c054f4c1a",
      lyrics: [
        "(Chorus)",
  "George Washington Carver was The Peanut Man.",
  "A great man he was.",
  "George Washington Carver was The Peanut Man.",
  "A great man he was.",
  
  "(Verse 1)",
  "George Washington Carver has an incredible story,",
  "He was born into slavery, in Missouri.",
  "Eager to learn, he moved around,",
  "Paying for school in every town.",
  "At Iowa State, he found his place,",
  "A master's degree, he earned with grace.",
  "A brilliant mind with a humble heart,",
  "In the world of science, he made his start.",
  "With peanuts, sweet potatoes, and plants galore,",
  "He showed the farmers how to grow more.",
  
  "(Chorus)",
  "George Washington Carver was The Peanut Man.",
  "A great man he was.",
  "George Washington Carver was The Peanut Man.",
  "A great man he was.",
  
  "(Verse 2)",
  "George Washington Carver taught southern farmers,",
  "How to plant other plants besides cotton.",
  "He introduced crop rotation,",
  "To save the soil from devastation.",
  "He discovered hundreds of uses for the peanut,",
  "From dyes and plastics to a tasty nut.",
  "His innovations helped many survive,",
  "Bringing new hope, keeping dreams alive.",
  
  "(Chorus)",
  "George Washington Carver was The Peanut Man.",
  "A great man he was.",
  "George Washington Carver was The Peanut Man.",
  "A great man he was.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
      ],
    },
    {
      title: "Susan B. Anthony",
      slug: "susanbanthony",
      standardNumber: "2.B.1",
      description: "Understand how values and beliefs shape culture in America.",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsusanbanthony2025video.mp4?alt=media&token=6cd6fce4-7ef3-4ed4-8e29-b216c404e70d",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsusanbanthony2025song.mp3?alt=media&token=ec7d574a-2ec3-46a0-9fac-10c200acb850",
      lyrics: [
        "(chorus)",
  "Gave speeches to end slavery",
  "and fought for alcohol abuse.",
  "To help women get equal rights, she took on that issue.",
  "Gave speeches to end slavery",
  "and fought for alcohol abuse.",
  "To help women get equal rights, she took on that issue.",
  
  "(verse)",
  "Susan B. Anthony was born February 15, 1820.",
  "Susan B. Anthony was born February 15, 1820.",
  "Susan fought for women to have the same rights as men.",
  "Susan fought for women to have the same rights as men.",
  "Susan fought for women to have the right to vote.",
  "Women voting in those times were illegal.",
  "Susan fought for civil rights; Susan fought for civil rights.",
  "Susan fought for women’s rights; Susan fought for women’s rights.",
  
  "(chorus)",
  "Gave speeches to end slavery",
  "and fought for alcohol abuse.",
  "To help women get equal rights, she took on that issue.",
  "Gave speeches to end slavery",
  "and fought for alcohol abuse.",
  "To help women get equal rights, she took on that issue.",
  
  "© Smart Board Learning, LLC. All rights reserved.",
      ],
    },
  
    // 2.C&G.1.1
    {
      title: "The Declaration of Independence",
      slug: "thedeclarationofindependence",
      standardNumber: "2.C&G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthedeclaration2025video.mp4?alt=media&token=5f196d84-24ce-4d49-9fc7-a5e1edf1040f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthedeclaration2025song.mp3?alt=media&token=a3535b3a-c748-41af-be89-0269139b63f8",
      lyrics: ["(Chorus)",
"The Declaration of Independence.",
"The Declaration of Independence.",

"(Verse)",
"All the reasons we have our independence,",
"Was written in The Declaration of Independence.",
"All the ideas we have for self-government,",
"Was written in The Declaration of Independence.",

"All people are created equal.",
"All people have rights to life.",
"All people have rights to liberty,",
"And the pursuit of happiness.",

"Thomas Jefferson was an author,",
"Of The Declaration of Independence.",

"(Chorus)",
"The Declaration of Independence.",
"The Declaration of Independence.",
"The Declaration of Independence.",
"The Declaration of Independence.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "The Constitution",
      slug: "theconstitution",
      standardNumber: "2.C&G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftheconstitutionvideo2025.mp4?alt=media&token=60be23b0-6432-4d5b-8503-6a99b6380b31",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftheconstitution2025song.mp3?alt=media&token=10bf0430-7e96-494d-944c-7bbbe1f81354",
      lyrics: ["(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 1)",
"The Constitution builds our government, step by step, you know it’s true!",
"It gives us leaders like the president, Congress, and the courts we use.",
"Each state has its own set of laws to guide its people every day,",
"but the U.S. Constitution is the highest, it leads the way!",
"In 1787, the framers made their plan, they made their plan.",
"George Washington, Ben Franklin, and others shaped this land.",
"They added amendments to protect our rights, so we’d be free.",
"And the government must follow them—it’s the law for you and me!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 2)",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"Added in 1791 to help our freedoms grow!",
"Added in 1791 to help our freedoms grow!",
"Thousands of changes were proposed, but only 27 were passed.",
"Thousands of changes were proposed, but only 27 were passed.",
"The Constitution stands the test of time, its strength will always last!",
"The Constitution stands the test of time, its strength will always last!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",]
    },

    // 2.C&G.1.3
    {
      title: "The Government",
      slug: "thegovernment",
      standardNumber: "2.C&G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthegovernmentvideo2025old.mp4?alt=media&token=d00d2200-0963-42d4-a6e6-c83a60a4c5e1",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthegovernment.mp3?alt=media&token=34f24faf-493f-44b6-bf3b-13b82cd6d489",
      lyrics: ["(chorus)",
"Governments make laws to protect the",
"rights and the property of everyone.",
"Governments make laws to protect the",
"rights and the property of everyone.",

"(verse)",
"Laws are made to keep people safe.",
"Laws are made to keep people safe.",
"Laws are made so order can be maintained.",
"Laws are made so order can be maintained.",
"The job of the government is to make laws.",
"The job of the government is to carry out laws.",
"The job of the government is to decide if laws have been broken.",

"(chorus)",
"Governments make laws to protect the",
"rights and the property of everyone.",
"Governments make laws to protect the",
"rights and the property of everyone.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
  
    // 2.C&G.1.4
    {
      title: "Equal Rights",
      slug: "equalrights",
      standardNumber: "2.C&G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fequalrights2025video.mp4?alt=media&token=58d730cc-6d5a-4889-b630-808aeabd908c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fequalrights2025song.mp3?alt=media&token=50a0be6b-0647-4069-a91b-12e34874e477",
      lyrics: ["(chorus)",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",

"(verse)",
"Susan B. Anthony helped women get equal rights.",
"That included the right to vote, that included the right to vote.",

"Jackie Robinson was the first African American",
"to play baseball in the major league, to play baseball in the major league.",

"Martin Luther King Jr. was an African American Minister",
"who worked for equal rights for all people.",

"Thurgood Marshall was a lawyer and the first African American Justice",
"of the U.S. Supreme Court, of the U.S. Supreme Court.",

"Rosa Parks was an African American Woman who refused",
"to give up her seat, and that led to a boycott",
"that helped change laws, change laws",

"(chorus)",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Dr. Martin Luther King Jr",
      slug: "drmartinlutherkingjr",
      standardNumber: "2.C&G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdrmartinlutherkingjr2025video.mp4?alt=media&token=df730bc0-7199-4a8b-bf51-509505e2a40c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdrmartinlutherking2025song.mp3?alt=media&token=cfe6a225-2726-4001-8161-8d5dcff1c13d",
      lyrics: ["(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"(Verse)",
"Dr. Martin Luther King Jr. was an African American man.",
"His father was a minister and Martin was a good student.",
"He was born in 1929 on January 15th.",
"He began college when he was only 15.",
"Dr. Martin Luther King Jr. became a minister just like his dad.",
"He worked hard to change laws that were unfair.",
"Dr. Martin Luther King Jr. gave his famous speech, “I Have a Dream.”",
"He was killed one day because he fought for what he believed.",

"(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
  
    // 2.E.1.1
    {
      title: "Wants & Choices",
      slug: "wantsandchoices",
      standardNumber: "2.E.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fwantsandchoices2025video.mp4?alt=media&token=46126733-76e4-468d-8dfd-2b3605f22776",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwantsandchoices2025song.mp3?alt=media&token=0cab7c9d-c510-4459-8e07-bd57a18920e6",
      lyrics: ["(Verse)",
"Things that we would like to have are called wants.",
"That’s what we want.",
"We can choose between two or more things, that’s a choice.",
"We have a choice.",
"Some choices that we make are made because we can’t have everything we want,",
"we want.",

"Things that we would like to have are called wants.",
"That’s what we want.",
"We can choose between two or more things, that’s a choice.",
"We have a choice.",
"Some choices that we make are made because we can’t have everything we want,",
"we want.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
  
    // 2.E.1.2
    {
      title: "Natural Resources",
      slug: "naturalresources",
      standardNumber: "2.E.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnaturalresources2025video.mp4?alt=media&token=41ca1ac8-d85f-4732-a6e8-31c0c0f5024f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnaturalresources2025song.mp3?alt=media&token=970befde-e5f3-490c-b6b6-695a05fbb105",
      lyrics: ["(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 1)",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",

"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",
"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 2)",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",

"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",
"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Producer",
      slug: "producer",
      standardNumber: "2.E.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fproducer2025video.mp4?alt=media&token=927f12da-8625-49c4-9b45-c6dc89b4ae06",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fproducer2025song.mp3?alt=media&token=9907f02f-44ae-4bdc-a63d-241c0140ca0d",
      lyrics: ["(verse)",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I make goods and I provide services.",
"I make goods and I provide services.",
"That makes me a producer,",
"that makes me a producer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"I use the goods and services that are made by the producers.",
"That makes me a consumer.",
"When resources are scarce, that means limited resources,",
"limited resources.",
"When resources are scarce, that means limited resources,",
"limited resources.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Cash Crop",
      slug: "cashcrop",
      standardNumber: "2.E.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcashcrops2025video.mp4?alt=media&token=b9e41c1b-30ab-4c73-96bf-5ce6d6041492",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcashcrops2025song.mp3?alt=media&token=efcc1137-a1a4-4040-9d13-0106a0b5321c",
      lyrics: ["(chorus)",
"Farming was very important to me.",
"I used my crops as money.",
"Farming was very important to me.",
"I used my crops as money.",
"They’re called cash crops, cash crops, cash crops.",
"They’re called cash crops, cash crops, cash crops.",

"(verse)",
"If we can find cheap labor,",
"we can make a lot of money planting tobacco.",
"If we can find cheap labor,",
"we can make a lot of money planting tobacco.",
"So African men, women and children were brought in",
"to work as slaves on the plantation.",
"African men, women and children were brought in",
"to work as slaves on the plantation.",

"(chorus)",
"Farming was very important to me.",
"I used my crops as money.",
"Farming was very important to me.",
"I used my crops as money.",
"They’re called cash crops, cash crops, cash crops.",
"They’re called cash crops, cash crops, cash crops.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
  
    // 2.G.1.1
    {
      title: "My Map",
      slug: "mymap",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fmymap2025video.mp4?alt=media&token=3291496b-9cbc-4a61-8810-acb3cacf3f99",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmymap2025song.mp3?alt=media&token=982b6c7f-d3c6-466b-9c7b-e77a491faf35",
      lyrics: ["(verse)",
"When we make a map,",
"when we make a map,",
"we must include the title.",
"That’s the name or kind of map.",
"When we make a map,",
"when we make a map,",
"we must include the title.",
"That’s the name or kind of map.",
"When we make a map,",
"when we make a map,",
"we must include the legend.",
"Symbols and what each one stands for.",
"When we make a map,",
"when we make a map,",
"we must include the legend.",
"Symbols and what each one stands for.",
"When we make a map",
"we must include a compass rose.",
"It shows directions,",
"North, south, east, and west.",
"When we make a map",
"we must include a compass rose.",
"It shows directions,",
"North, south, east, and west.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Coordinates",
      slug: "coordinates",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcoordinates2025video.mp4?alt=media&token=da24a868-2bbf-4c8c-acbd-93c47d9f28bd",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcoordinates2025song.mp3?alt=media&token=4e3cd02c-f4d9-4079-9a6d-8854fc2d2c1e",
      lyrics: ["(chorus)",
"We can look on a map and find a location",
"by using coordinates, by using coordinates.",
"We can look on a map and find a location",
"by using coordinates, by using coordinates.",

"(verse)",
"Just look for the letter on the left, on the left.",
"Then, find the number at the bottom of the map.",
"Next, we’ll go to the spot where the letter and the number meet,",
"and that will be your location.",
"Just look for the letter on the left, on the left.",
"Then, find the number at the bottom of the map.",
"Next, we’ll go to the spot where the letter and the number meet,",
"and that will be your location.",

"(chorus)",
"We can look on a map and find a location",
"by using coordinates, by using coordinates.",
"We can look on a map and find a location",
"by using coordinates, by using coordinates.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Hemisphere",
      slug: "hemisphere",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fhemispheres.mp4?alt=media&token=34d76b2b-6ca8-48ac-b82a-01058a8c7d8f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2F(3.5b)%20HEMISPHERES.mp3?alt=media&token=d83a018b-9d2c-4351-88b8-c299d2f08752",
      lyrics: ["(verse)",
"The prime meridian divides the Earth, divides the Earth,",
"into the Eastern hemisphere, into the Western hemisphere.",
"The prime meridian is an imaginary line that",
"divides the Earth, divides the Earth,",
"divides the Earth, divides the Earth.",

"The equator divides the Earth, divides the Earth,",
"into the Northern hemisphere, into the Southern hemisphere.",
"The equator is an imaginary line that",
"divides the Earth, divides the Earth,",
"divides the Earth, divides the Earth.",

"The equator divides the Earth, divides the Earth,",
"into the Northern hemisphere, into the Southern hemisphere.",
"The equator is an imaginary line that",
"divides the Earth, divides the Earth,",
"divides the Earth, divides the Earth.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Continents & Oceans",
      slug: "continentsandoceans",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fcontinentsandoceans2021.mp4?alt=media&token=dfa953f5-3c7a-4eaa-8324-7c30ad8495ab",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcontinentsandoceans2025song.mp3?alt=media&token=8009685b-ddfb-459c-b393-739b04808f60",
      lyrics: ["(Verse)",
"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",
"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",

"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",
"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",

"There are seven continents in this world, in this world.",
"There are seven continents in this world, in this world.",
"Africa, Antarctica, Asia, Australia,",
"Europe, North America, South America.",
"There are five major oceans in this world, in this world.",
"There are five major oceans in this world, in this world.",
"The Pacific Ocean, the Atlantic Ocean, the Indian Ocean,",
"The Arctic, and Southern Ocean.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
  
    // 2.G.1.2
    {
      title: "Surviving Seasons",
      slug: "survivingseasons",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fsurvivingseasons2022.mp4?alt=media&token=6b4da363-4ebc-46ae-ace2-4993a44cb1dc",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FSURVIVING%20SEASONS%20(VS.2e).mp3?alt=media&token=09a254e9-ed63-47c6-95cf-65d75dfd8d5f",
      lyrics: ["(verse)",
"In the Winter,",
"we hunted birds.",
"In the Winter,",
"we hunted animals.",

"In the Spring,",
"we fished, hunted and picked berries.",
"In the Spring,",
"we fished, hunted and picked berries.",

"In the Summer we grew crops,",
"beans, corn, and squash.",
"In the Summer we grew crops,",
"beans, corn and squash.",

"In the Fall we picked our crops.",
"We hunted for food to store for the Winter.",
"In the Fall we picked our crops.",
"We hunted for food to store for the Winter.",

"(chorus)",
"How do we survive the Seasons?",
"How do we survive the Seasons?",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Location",
      slug: "location",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Flocation2022.mp4?alt=media&token=68fe4786-d562-4df5-b68c-f48c95fb5ea0",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FLOCATION%20(VS.3b).mp3?alt=media&token=49f55b79-2e84-4899-b9cc-f883f15c48fe",
      lyrics: ["(chorus)",
"When the settlers came in 1607,",
"Jamestown was located on a Peninsula.",
"When the settlers came in 1607,",
"Jamestown was located on a Peninsula.",
"Why choose this location? Why choose this location?",
"Because, because, because, because…",
"(verse)",
"They thought that this area had a good supply of fresh water.",
"Along the shore the water was deep enough for the ships to pull in.",
"They thought that this location could easily be defended",
"against attack from the sea.",
"They thought that this location could easily be defended",
"against attack from the sea.",
"(chorus)",
"When the settlers came in 1607,",
"Jamestown was located on a Peninsula.",
"When the settlers came in 1607,",
"Jamestown was located on a Peninsula."]
    },
    {
      title: "Settled",
      slug: "settled",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsettled2022.mp4?alt=media&token=ccafb686-6eab-4cfe-b145-0fd1c3cf81b8",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsettled2025song.mp3?alt=media&token=c0f9efb7-febe-47bd-b658-311e40b076ad",
      lyrics: ["(Chorus)",
"In 1607, the English settled in Jamestown.",
"In 1607, the English settled in Jamestown.",
"Why bring colonies to America?",
"To increase the wealth and power.",
"Why bring colonies to America?",
"To find silver and gold.",
"Why bring colonies to America?",
"To open up new markets for trade.",
"Why bring colonies to America?",
"To get raw materials.",

"(Verse)",
"The Virginia Company of London’s stockholders,",
"Paid for the settlement.",
"They settled on a peninsula, surrounded on three sides by the James River.",
"The area was good for trade.",
"From the Spanish, they thought they were safe.",
"From the Spanish, they thought they were safe.",
"Their ships could come in to dock.",
"They thought their water supply was good.",

"(Chorus)",
"In 1607, the English settled in Jamestown.",
"In 1607, the English settled in Jamestown.",
"Why bring colonies to America?",
"To increase the wealth and power.",
"Why bring colonies to America?",
"To find silver and gold.",
"Why bring colonies to America?",
"To open up new markets for trade.",
"Why bring colonies to America?",
"To get raw materials.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
  
    // 2.G.1.3
    {
      title: "Settlers Moving",
      slug: "settlersmoving",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsettlersmoving2025video.mp4?alt=media&token=1ed9a29f-cd2f-4466-9588-c2d4669ced98",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsettlersmoving2025song.mp3?alt=media&token=a3b03e7f-790d-4b0d-b32a-2c1c1f0f3a2c",
      lyrics: ["(chorus)",
"Settlers started to move between 1801 and 1861.",
"Settlers started to move between 1801 and 1861.",

"(verse)",
"Reasons:",
"To find cheap and fertile land",
"with new opportunities that come along with it.",
"Reasons:",
"Faster transportation, rivers and canals.",
"Reasons:",
"Economic opportunities like the California Gold Rush, farming and logging.",
"Reasons:",
"People believed that expansion was good for our country.",

"(chorus)",
"Settlers started to move between 1801 and 1861.",
"Settlers started to move between 1801 and 1861.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "America Grew",
      slug: "americagrew",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Famericagrew2025video.mp4?alt=media&token=a51ccf77-0dbc-419b-b6a1-8365858612da",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Famericagrew2025song.mp3?alt=media&token=90f41d56-7c74-4bf2-9e8c-c4d117e6ab3c",
      lyrics: ["(Chorus)",
"Between 1801 and 1861 The United States grew,", 
"The United States grew.",
"Between 1801 and 1861 The United States grew,", 
"The United States grew.",
"(Verse)",
"The Louisiana Purchase doubled the size of The United States, The United States.",
"Through a treaty, Florida was given by Spain to The United States, The United States.",
"Texas became independent from Mexico to be part of The United States, The United States.",
"The Oregon Territory was split by Great Britain and The United States, The United States.",
"After the Mexican-American War, California became part of The United States, The United States.",
"(Chorus)",
"Between 1801 and 1861 The United States grew,", 
"The United States grew.",
"Between 1801 and 1861 The United States grew,", 
"The United States grew.",
"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Countries Explored",
      slug: "countriesexplored",
      standardNumber: "2.G.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcountriesexplored2025.mp3?alt=media&token=07bb223e-3e91-4111-b518-09a900f19e7c",
      lyrics: ["(chorus)",
"Countries explored to spread religion.",
"Countries explored for the competition.",
"Countries explored for trade and for gold.",
"Countries explored for resources that’s natural.",

"(verse)",
"During exploration, people starved and caught diseases.",
"During exploration, they had poor maps and navigation.",
"During exploration, they didn’t have proper supplies.",
"During exploration, they didn’t know what lay ahead.",

"(bridge)",
"Explorers exchanged goods with those they encountered.",
"Explorers exchanged ideas with those they encountered.",
"Explorers claimed territories,",
"Explorers claimed territories.",

"(chorus)",
"Countries explored to spread religion.",
"Countries explored for the competition.",
"Countries explored for trade and for gold.",
"Countries explored for resources that’s natural.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
  
    // 2.H.1.1
    {
      title: "People",
      slug: "people",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fpeople2025video.mp4?alt=media&token=957a3212-a73d-4f78-a3b1-dc6a4079acd3",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fpeople2025song.mp3?alt=media&token=8359150c-fa84-4aa0-8283-e4a3fe001ef4",
      lyrics: ["(chorus)",
"People from our past.",
"These are people from our past.",

"(verse)",
"George Washington was our 1st President.",
"George Washington was our 1st President.",
"He was called the Father of our Country.",
"He was called the Father of our Country.",
"Abraham Lincoln was our 16th President.,",
"Abraham Lincoln was our 16th President.",
"He was called Honest Abe.",
"He was called Honest Abe.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",

"(chorus)",
"People from our past.",
"These are people from our past.",
"These are people from our past.",

"(verse)",
"George Washington was our 1st President.",
"George Washington was our 1st President.",
"He was called the Father of our Country.",
"He was called the Father of our Country.",
"Abraham Lincoln was our 16th President.",
"Abraham Lincoln was our 16th President.",
"He was called Honest Abe.",
"He was called Honest Abe.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",
"Betsy Ross, a long time ago, had sewn one of the first American flags.",

"(chorus)",
"People from our past.",
"These are people from our past.",
"These are people from our past.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Benjamin Franklin",
      slug: "benjaminfranklin",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fbenjaminfranklin2025video.mp4?alt=media&token=d3b4d87c-b523-4e1f-89f8-3a030ae0ad62",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fbenjaminfranklin2025song.mp3?alt=media&token=931e278a-40ea-405d-acae-a99e4cc1951d",
      lyrics: ["(Chorus)",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",

"(Verse 1)",
"Benjamin Franklin invented bifocals.",
"Bifocals or glasses, if you don't know.",
"Benjamin wanted to prove that lightning is electricity.",
"So, Benjamin conducted a famous kite experiment with a key.",
"Benjamin helped to start America's first library.",
"He helped to put streetlights and paved roads in Philadelphia, the city.",

"(Chorus)",
"Benjamin Franklin.",
"Benjamin Franklin.",

"(Verse 2)",
"The Declaration of Independence was partly written by Benjamin.",
"Benjamin also signed the United States Constitution.",
"Benjamin Franklin was a scientist and an inventor.",
"Benjamin Franklin was a writer and a leader.",
"Benjamin Franklin’s face is on the hundred bill I spent.",
"What Benjamin Franklin was not? He was not President.",

"(Chorus)",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",
"Benjamin Franklin.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Abraham Lincoln",
      slug: "abrahamlincoln",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fabrahamlincoln2025video.mp4?alt=media&token=37424f34-5f48-4d9f-af6a-526d9b14872d",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fabrahamlincoln.mp3?alt=media&token=bae458d6-0b42-4392-aeb4-3d24c7adc90d",
      lyrics: ["(chorus)",
"Abraham Lincoln was the 16th, President.",
"Abraham Lincoln, a United States resident.",
"Abraham Lincoln, Abraham, Abraham,",
"Abraham Lincoln, Abraham, Abraham.",

"(verse 1)",
"Abraham Lincoln, a President of mine,",
"was born February 12, 1809.",
"Abraham Lincoln was born in Kentucky.",
"Abraham Lincoln really loved to read.",
"On his father's farm he would chop down trees",
"and plowed the land.",
"He helped his family.",
"When Abraham grew up, he worked in a store.",
"Abraham became a mailman, then he became a lawyer.",

"(chorus)",
"Abraham Lincoln was the 16th, President.",
"Abraham Lincoln, a United States resident.",
"Abraham Lincoln, Abraham, Abraham,",
"Abraham Lincoln, Abraham, Abraham.",

"(verse 2)",
"Abraham Lincoln made a life choice",
"when he married Mary Todd and they had four boys.",
"Then Abraham Lincoln, a United States resident",
"became the 16th president.",
"During Abraham’s presidency",
"the Civil War began, a very long time for our country.",
"Abraham Lincoln was a great leader.",
"He freed the slaves and held our country together.",

"(chorus)",
"Abraham Lincoln was the 16th, President.",
"Abraham Lincoln, a United States resident.",
"Abraham Lincoln, Abraham, Abraham,",
"Abraham Lincoln, Abraham, Abraham.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Equal Rights",
      slug: "equalrights",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fequalrights2025video.mp4?alt=media&token=58d730cc-6d5a-4889-b630-808aeabd908c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fequalrights2025song.mp3?alt=media&token=50a0be6b-0647-4069-a91b-12e34874e477",
      lyrics: ["(chorus)",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",

"(verse)",
"Susan B. Anthony helped women get equal rights.",
"That included the right to vote, that included the right to vote.",

"Jackie Robinson was the first African American",
"to play baseball in the major league, to play baseball in the major league.",

"Martin Luther King Jr. was an African American Minister",
"who worked for equal rights for all people.",

"Thurgood Marshall was a lawyer and the first African American Justice",
"of the U.S. Supreme Court, of the U.S. Supreme Court.",

"Rosa Parks was an African American Woman who refused",
"to give up her seat, and that led to a boycott",
"that helped change laws, change laws",

"(chorus)",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",
"They fought for equal rights.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Dr. Martin Luther King Jr",
      slug: "drmartinlutherkingjr",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fdrmartinlutherkingjr2025video.mp4?alt=media&token=df730bc0-7199-4a8b-bf51-509505e2a40c",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdrmartinlutherking2025song.mp3?alt=media&token=cfe6a225-2726-4001-8161-8d5dcff1c13d",
      lyrics: ["(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"(Verse)",
"Dr. Martin Luther King Jr. was an African American man.",
"His father was a minister and Martin was a good student.",
"He was born in 1929 on January 15th.",
"He began college when he was only 15.",
"Dr. Martin Luther King Jr. became a minister just like his dad.",
"He worked hard to change laws that were unfair.",
"Dr. Martin Luther King Jr. gave his famous speech, “I Have a Dream.”",
"He was killed one day because he fought for what he believed.",

"(Chorus)",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Nobel Peace Prize winner.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",
"Dr. Martin Luther King Jr.",
"Fought for equal rights.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
  
    // 2.H.1.2
    {
      title: "The Declaration of Independence",
      slug: "thedeclarationofindependence",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthedeclaration2025video.mp4?alt=media&token=5f196d84-24ce-4d49-9fc7-a5e1edf1040f",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fthedeclaration2025song.mp3?alt=media&token=a3535b3a-c748-41af-be89-0269139b63f8",
      lyrics: ["(Chorus)",
"The Declaration of Independence.",
"The Declaration of Independence.",

"(Verse)",
"All the reasons we have our independence,",
"Was written in The Declaration of Independence.",
"All the ideas we have for self-government,",
"Was written in The Declaration of Independence.",

"All people are created equal.",
"All people have rights to life.",
"All people have rights to liberty,",
"And the pursuit of happiness.",

"Thomas Jefferson was an author,",
"Of The Declaration of Independence.",

"(Chorus)",
"The Declaration of Independence.",
"The Declaration of Independence.",
"The Declaration of Independence.",
"The Declaration of Independence.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Articles of Confederation",
      slug: "articlesofconfederation",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Farticles2025video.mp4?alt=media&token=b8520371-f7b1-4542-8fc3-27d6faccc5db",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Farticles2025song.mp3?alt=media&token=6c495c05-673e-4d8c-8b2b-a932189e23ae",
      lyrics: ["(Chorus)",
"During the American Revolution,",
"The Articles of Confederation was a constitution.",
"During the American Revolution,",
"The Articles of Confederation was a constitution.",

"(Verse)",
"Under the Articles of Confederation",
"we had a weak national government.",
"Under the Articles of Confederation",
"each State had one vote regardless of the State’s size.",
"Under the Articles of Confederation",
"we had no executive branch, we had no judicial branch.",
"Under the Articles of Confederation",
"Congress didn’t have power to tax or regulate commerce.",

"(Chorus)",
"During the American Revolution,",
"The Articles of Confederation was a constitution.",
"During the American Revolution,",
"The Articles of Confederation was a constitution.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "The Constitution",
      slug: "theconstitution",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ftheconstitutionvideo2025.mp4?alt=media&token=60be23b0-6432-4d5b-8503-6a99b6380b31",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ftheconstitution2025song.mp3?alt=media&token=10bf0430-7e96-494d-944c-7bbbe1f81354",
      lyrics: ["(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 1)",
"The Constitution builds our government, step by step, you know it’s true!",
"It gives us leaders like the president, Congress, and the courts we use.",
"Each state has its own set of laws to guide its people every day,",
"but the U.S. Constitution is the highest, it leads the way!",
"In 1787, the framers made their plan, they made their plan.",
"George Washington, Ben Franklin, and others shaped this land.",
"They added amendments to protect our rights, so we’d be free.",
"And the government must follow them—it’s the law for you and me!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",

"(Verse 2)",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"The Bill of Rights came later, it’s the first ten amendments we know.",
"Added in 1791 to help our freedoms grow!",
"Added in 1791 to help our freedoms grow!",
"Thousands of changes were proposed, but only 27 were passed.",
"Thousands of changes were proposed, but only 27 were passed.",
"The Constitution stands the test of time, its strength will always last!",
"The Constitution stands the test of time, its strength will always last!",

"(Chorus)",
"What is the Constitution?",
"It’s the highest law of our land, you see!",
"What is the Constitution?",
"It’s the guide for you and me!",
"All our laws come from its words,",
"That’s how our rights are always heard.",
"All our laws come from its words,",
"That’s how our rights are always heard.",]
    },
    {
      title: "GB & The Colonies",
      slug: "gbandthecolonies",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "",
      music: "",
      lyrics: []
    },
    {
      title: "The First 5",
      slug: "thefirst5",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Ffirstfive2025video.mp4?alt=media&token=35096015-7757-41c6-9844-9f289c9c82b1",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Ffirstfive2025song.mp3?alt=media&token=30cb6fb7-96d7-42a8-ae81-e453554f27dd",
      lyrics: ["(chorus)",
"United States, first five presidents.",
"United States, first five presidents.",
"United States, first five presidents.",
"United States, first five presidents.",

"(verse)",
"When George Washington was our first president,",
"the Bill of Rights was added to the Constitution.",
"When John Adams was our second president,",
"we were divided into two political parties.",
"When Thomas Jefferson was our third president,",
"he brought Louisiana from France and Lewis & Clark explored new lands.",
"When James Madison was our fourth president,",
"we fought in the War of 1812, we fought in the War of 1812.",
"When James Monroe was our fifth president,",
"he made the Monroe Doctrine, he made the Monroe Doctrine.",

"(chorus)",
"United States, first five presidents.",
"United States, first five presidents.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "The Arrival",
      slug: "thearrival",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fthearrival2022.mp4?alt=media&token=bdba34f5-7e5d-4632-a4c7-c58dc067f315",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FTHE%20ARRIVAL%20(VS.3e).mp3?alt=media&token=75280ffa-9981-44e1-a942-27481d719218",
      lyrics: ["(chorus)",
"When the African men and women arrived in Jamestown,",
"in 1619, in 1619.",
"When the African men and women arrived in Jamestown,",
"in 1619, in 1619.",

"(verse)",
"They had an impact on the way things were going,",
"they were slaves or servants.",
"They helped the tobacco business grow,",
"and more women made it possible for families to settle.",
"In Jamestown, in Jamestown,",
"in Jamestown, in Jamestown.",

"(chorus)",
"When the African men and women arrived in Jamestown,",
"in 1619, in 1619.",
"When the African men and women arrived in Jamestown,",
"in 1619, in 1619.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "General Assembly",
      slug: "generalassembly",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fgeneralassembly2022.mp4?alt=media&token=343bd143-587d-44cf-91e5-1391234c3246",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsocial-studies-music%2FGENERAL%20ASSEMBLY%20(VS.3d).mp3?alt=media&token=e446f867-8b49-442a-9871-ceed93d41398",
      lyrics: ["(verse)",
"The General Assembly 1619,",
"The General Assembly 1619,",
"The General Assembly 1619.",
"The Governor,",
"The Governors council,",
"Two representatives of each",
"of the divisions of Virginia,",
"called Burgesses,",
"called Burgesses.",
"The General Assembly,",
"The General Assembly.",
"Around 1640, The Burgesses separated",
"and became its own body of legislation,",
"called The House of Burgesses.",
"They were elected by the settlers,",
"called The House of Burgesses.",
"They were elected by the settlers.",
"House of Burgesses,",
"House of Burgesses,",
"House of Burgesses,",
"House of Burgesses.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Charter",
      slug: "charter",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsocial-studies-videos%2Fcharters2022.mp4?alt=media&token=9a795227-7a84-4231-b703-1e62809ec589",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fcharters2025song.mp3?alt=media&token=82c3b635-216b-4e3c-95ed-07168e29ea3f",
      lyrics: ["(chorus)",
"Charters were granted by the King of England",
"for the settlement in North America.",
"Charters were granted by the King of England",
"for the settlement in North America.",

"(verse)",
"Charters were granted to the Virginia Company of London",
"to establish a settlement in North America.",
"Charters were granted to the Virginia Company of London",
"to establish a settlement in North America.",
"A charter is a document that states the rights and laws for the people,",
"a charter is a document that states the rights and laws for the people.",

"(chorus)",
"Charters were granted by the King of England",
"for the settlement in North America.",
"Charters were granted by the King of England",
"for the settlement in North America.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Hard Living",
      slug: "hardliving",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fhardliving2025video.mp4?alt=media&token=86619e66-6300-4fcc-b6d5-7249b40d7c51",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2FHARD%20LIVING%20(VS.3f).mp3?alt=media&token=c8f4ad9f-a0dc-4c8f-ab21-9d32d75d57f0",
      lyrics: ["(chorus)",
"In Jamestown, the English found",
"that surviving was not as easy as they thought it would be.",
"In Jamestown, the English found",
"that surviving was not as easy as they thought it would be.",

"(verse)",
"Many settlers died of starvation.",
"Many settlers died from disease.",
"The area that they chose to settle in was marshy,",
"and they did not have much safe water to drink.",
"So supply ships came in",
"led by John Smith the Captain,",
"they would work hard and do a lot of farming",
"for the colony to survive.",

"(chorus)",
"In Jamestown, the English found",
"that surviving was not as easy as they thought it would be.",
"In Jamestown, the English found",
"that surviving was not as easy as they thought it would be.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },
    {
      title: "Settled",
      slug: "settled",
      standardNumber: "2.H.1",
      description: "",
      gameType: "multipleChoice",
      titleImage: "",
      video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fsettled2022.mp4?alt=media&token=ccafb686-6eab-4cfe-b145-0fd1c3cf81b8",
      music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fsettled2025song.mp3?alt=media&token=c0f9efb7-febe-47bd-b658-311e40b076ad",
      lyrics: ["(Chorus)",
"In 1607, the English settled in Jamestown.",
"In 1607, the English settled in Jamestown.",
"Why bring colonies to America?",
"To increase the wealth and power.",
"Why bring colonies to America?",
"To find silver and gold.",
"Why bring colonies to America?",
"To open up new markets for trade.",
"Why bring colonies to America?",
"To get raw materials.",

"(Verse)",
"The Virginia Company of London’s stockholders,",
"Paid for the settlement.",
"They settled on a peninsula, surrounded on three sides by the James River.",
"The area was good for trade.",
"From the Spanish, they thought they were safe.",
"From the Spanish, they thought they were safe.",
"Their ships could come in to dock.",
"They thought their water supply was good.",

"(Chorus)",
"In 1607, the English settled in Jamestown.",
"In 1607, the English settled in Jamestown.",
"Why bring colonies to America?",
"To increase the wealth and power.",
"Why bring colonies to America?",
"To find silver and gold.",
"Why bring colonies to America?",
"To open up new markets for trade.",
"Why bring colonies to America?",
"To get raw materials.",

"© Smart Board Learning, LLC. All rights reserved.",]
    },

];
export default topics;
